import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  skeletonRoot: {
    display: 'flex',
    padding: theme.spacing(0.5, 1),
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: theme.spacing(0.75)
  }
}));

export const ResourceMatchItemSkeleton = ({ dataQeId }) => {
  const classes = useStyles();

  return (
    <div
      data-qe-id={
        dataQeId ? `${dataQeId}_ResourceMatchItemSkeleton` : undefined
      }
      className={classes.skeletonRoot}
    >
      <Skeleton width="100%" height={39} />
    </div>
  );
};

ResourceMatchItemSkeleton.propTypes = {
  dataQeId: PropTypes.string
};

export default ResourceMatchItemSkeleton;
